<div class="modal-dialog modal-lg modal-fullscreen-md-down modal-dialog-centered modal-dialog-scrollable" role="document">
	<div class="modal-content">
		<div class="modal-header">
			<h5 class="modal-title">Munkalap adatai</h5>
			<button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
		</div>
		<div class="modal-body p-0">
			<div class="container">
				<div class="row">
					<div class="col p-0">

						<!-- Tab navigation -->
						<ul class="nav nav-pills m-2">
							<li class="nav-item">
								<button class="nav-link <% if (!issue.id) { %>active<% } %>"" data-bs-toggle="tab" data-bs-target="#issue-tab-base" type="button" onclick="$('#issue-modal-content').removeClass('thread');">Alapadatok</button>
							</li>
							<li class="nav-item">
								<button class="nav-link" data-bs-toggle="tab" data-bs-target="#issue-tab-binding" type="button" onclick="$('#issue-modal-content').removeClass('thread');">Társítás</button>
							</li>
							<li class="flex-grow-1"></li>
							<li>
								<button class="nav-link <% if (issue.id) { %>active<% } else { %>disabled<% } %>" data-bs-toggle="tab" data-bs-target="#issue-tab-thread" type="button" onclick="$('#issue-modal-content').addClass('thread');">Szál</button>
							</li>
							<li>
								<div class="dropdown">
									<button type="button" class="btn btn-warning ms-2 <% if (issue.closed) { %>disabled<% } %>" style="height:35px; padding:0 12px;" data-bs-toggle="dropdown" data-bs-auto-close="outside"><i class="fa fa-fw fa-lock"></i></button>
									<div class="dropdown-menu px-3">
										<p>Biztosan lezárod ezt a munkalapot?</p>
										<button class="btn btn-sm btn-dark text-danger w-100" onclick="Anvil.page.modal.save(true)"><i class="fa fa-fw fa-lock"></i> Igen, lezárom!</button>
									</div>
								</div>
							</li>
						</ul>

						<hr class="m-0" />

						<div class="d-flex flex-column <% if (issue.id) { %>thread<% } %>" id="issue-modal-content">

							<div class="flex-grow-1 flex-shrink-1 overflow-y-auto">

								<!-- Tab content -->
								<div class="tab-content">

									<!-- Alapadatok tab -->
									<div class="tab-pane p-3 <% if (!issue.id) { %>show active<% } %>" id="issue-tab-base" role="tabpanel">

										<%- include('/ui/form', {
											params: [ 'issue', issue ],
											fields: [
												{
													type: 'text',
													name: 'title',
													title: 'Téma',
													attributes: issue.closed ? { readonly: 'readonly' } : null
												},
												{
													type: 'group',
													title: 'Jelleg, prioritás',
													fields: [
														{
															type: 'select',
															name: 'work_tags',
															title: 'Jelleg',
															params: {
																maxItems: null,
																options: issue_tags.data.filter(t => t.type == 'work'),
																optgroupField: 'type',
																valueField: 'id',
																labelField: 'name',
																searchField: [ 'name' ],
																render: {
																	item: (item, esc) => `<div style="background-color:${item.color};" title="${esc(item.name)}"><i class="${item.icon} fa-fw fa-sm"></i></div>`,
																	option: (item, esc) => `<div class="option"><i class="${item.icon ? item.icon : 'fa fa-sm fa-circle'} fa-fw fa-sm me-2" style="color:${item.color};"></i>${esc(item.name)}</div>`
																}
															},
															unset_value: null,
															attributes: issue.closed ? { disabled: 'disabled' } : null
														},
														{
															type: 'select',
															name: 'priority_tag',
															title: 'Prioritás',
															params: {
																maxItems: 1,
																options: issue_tags.data.filter(t => t.type == 'priority'),
																optgroupField: 'type',
																valueField: 'id',
																labelField: 'name',
																searchField: [ 'name' ],
																render: {
																	item: (item, esc) => `<div title="${esc(item.name)}"><i class="${item.icon} fa-fw fa-sm me-2" style="color:${item.color};"></i>${esc(item.name)}</div>`,
																	option: (item, esc) => `<div class="option"><i class="${item.icon ? item.icon : 'fa fa-sm fa-circle'} fa-fw fa-sm me-2" style="color:${item.color};"></i>${esc(item.name)}</div>`
																}
															},
															unset_value: null,
															attributes: issue.closed ? { disabled: 'disabled' } : null
														}
													]
												},
												{
													type: 'select',
													name: 'tags',
													title: 'Projekt',
													params: {
														maxItems: null,
														options: issue_tags.data.filter(t => t.type == 'project'),
														valueField: 'id',
														labelField: 'name',
														searchField: [ 'name' ],
														render: {
															item: (item, esc) => `<div style="background-color:${item.color};"><i class="${item.icon} fa-fw fa-sm me-1"></i>${esc(item.name)}</div>`,
															option: (item, esc) => `<div class="option"><i class="${item.icon ? item.icon : 'fa fa-sm fa-circle'} fa-fw fa-sm me-2" style="color:${item.color};"></i>${esc(item.name)}</div>`
														}
													},
													unset_value: null,
													attributes: issue.closed ? { disabled: 'disabled' } : null
												},
												{
													type: 'textarea',
													name: 'description',
													title: 'Részletek',
													attributes: issue.closed ? { readonly: 'readonly', style: 'height: 285px;' } : { style: 'height: 285px;' }
												},
												{
													type: 'select',
													name: 'responsible_user_id',
													title: 'Felelős',
													dropup: true,
													params: {
														maxItems: 1,
														options: users.data.filter(x => x.active == 1),
														valueField: 'id',
														labelField: 'account_name',
														searchField: [ 'account_name' ],
														render: {
															item: (item, esc) => `<div><i class="fa fa-fw fa-sm fa-user me-2"></i>${esc(item.account_name)}</div>`,
															option: (item, esc) => `<div class="option"><i class="fa fa-fw fa-sm fa-user me-2"></i>${esc(item.account_name)}</div>`
														}
													},
													unset_value: null,
													attributes: issue.closed ? { disabled: 'disabled' } : null
												},
												{
													type: 'select',
													name: 'worker_user_ids',
													title: 'További résztvevők',
													dropup: true,
													params: {
														maxItems: null,
														options: users.data.filter(x => x.active == 1),
														valueField: 'id',
														labelField: 'account_name',
														searchField: [ 'account_name' ],
														render: {
															item: (item, esc) => `<div style="background-color:#234; color:#ccc;"><i class="fa fa-fw fa-sm fa-user me-2"></i>${esc(item.account_name)}</div>`,
															option: (item, esc) => `<div class="option"><i class="fa fa-fw fa-sm fa-user me-2"></i>${esc(item.account_name)}</div>`
														}
													},
													unset_value: null,
													attributes: issue.closed ? { disabled: 'disabled' } : null
												}
											]
										}) %>

									</div>

									<!-- Társítás tab -->
									<div class="tab-pane p-3" id="issue-tab-binding" role="tabpanel">

										<%- include('/ui/form', {
											params: [ 'issue_link', issue ],
											fields: [
												{
													type: 'select',
													name: 'link',
													title: 'Társítás típusa',
													params: {
														options: [
															{ value: 'company', label: 'Cég' },
															{ value: 'database', label: 'Adatbázis' },
															{ value: 'site', label: 'Telephely' },
															{ value: 'terminal', label: 'Terminál' },
															{ value: 'aee', label: 'Pénztárgép' }
														],
														valueField: 'value',
														labelField: 'label',
													},
													unset_value: null,
													attributes: issue.closed ? { disabled: 'disabled' } : null,
													update: (value) => {

														// Reset values
														if (value == 'company') {
															Anvil.page.modal.issue.company_db_id = null
															Anvil.page.modal.issue.site_id = null
															Anvil.page.modal.issue.terminal_id = null
															Anvil.page.modal.issue.aee_id = null
														}

														if (value == 'database') {
															Anvil.page.modal.issue.site_id = null
															Anvil.page.modal.issue.terminal_id = null
															Anvil.page.modal.issue.aee_id = null
														}

														if (value == 'site') {
															Anvil.page.modal.issue.terminal_id = null
															Anvil.page.modal.issue.aee_id = null
														}

														if (value == 'terminal') {
															Anvil.page.modal.issue.aee_id = null
														}

														// Re-render database picker
														Anvil.render('/issue/modal_edit_panel_link_database', {}, '#panel-link-database')
														// Re-render site picker
														Anvil.render('/issue/modal_edit_panel_link_site', {}, '#panel-link-site')
														// Re-render terminal picker
														Anvil.render('/issue/modal_edit_panel_link_terminal', {}, '#panel-link-terminal')
														// Re-render aee picker
														Anvil.render('/issue/modal_edit_panel_link_aee', {}, '#panel-link-aee')
													}
												},
												{
													type: 'html',
													content: '<br />'
												},
												{
													type: 'select',
													name: 'company_id',
													title: 'Cég',
													params: {
														maxItems: 1,
														options: Anvil.page.modal.companies.data,
														valueField: 'id',
														labelField: 'name',
														searchField: [ 'tax_number', 'name' ],
														render: {
															item: (item, esc) => `<div>${esc(item.name)}<br /><small>${esc(item.tax_number)}</small></div>`,
															option: (item, esc) => `<div class="option">${esc(item.name)}<br /><small>${esc(item.tax_number)}</small></div>`
														}
													},
													unset_value: null,
													attributes: issue.closed ? { disabled: 'disabled' } : null,
													update: (value) => {

														// Reset values
														Anvil.page.modal.issue.company_db_id = null
														Anvil.page.modal.issue.site_id = null
														Anvil.page.modal.issue.terminal_id = null
														Anvil.page.modal.issue.aee_id = null

														// Re-render database picker
														Anvil.render('/issue/modal_edit_panel_link_database', {}, '#panel-link-database')
														// Re-render site picker
														Anvil.render('/issue/modal_edit_panel_link_site', {}, '#panel-link-site')
														// Re-render terminal picker
														Anvil.render('/issue/modal_edit_panel_link_terminal', {}, '#panel-link-terminal')
														// Re-render aee picker
														Anvil.render('/issue/modal_edit_panel_link_aee', {}, '#panel-link-aee')
													}
												}
											]
										}) %>
										<div id="panel-link-database">
											<%- include('/issue/modal_edit_panel_link_database', {}) %>
										</div>
										<div id="panel-link-site">
											<%- include('/issue/modal_edit_panel_link_site', {}) %>
										</div>
										<div id="panel-link-terminal">
											<%- include('/issue/modal_edit_panel_link_terminal', {}) %>
										</div>
										<div id="panel-link-aee">
											<%- include('/issue/modal_edit_panel_link_aee', {}) %>
										</div>

									</div>

									<!-- Szál tab -->
									<div class="tab-pane p-3 <% if (issue.id) { %>show active<% } %> h-100" id="issue-tab-thread" role="tabpanel" <% if (issue.id) { %>onclick="$('')"<% } %>>

										<div id="issue-thread">
											<%- include('/issue/modal_edit_panel_thread', { issue }) %>
										</div>
									</div>
								</div>
							</div>

							<div class="modal-footer text-end d-flex flex-shrink-0 p-3">
								<% if (issue.closed) { %>
								<button type="button" class="btn btn-danger" onclick="Anvil.page.modal.save(false)"><i class="fa fa-unlock me-2"></i>Visszanyitás</button>
								<% } else { %>

								<div id="issue-actions">
									<button type="button" class="btn btn-primary" onclick="Anvil.page.modal.save()"><i class="fa fa-save me-2"></i>Mentés</button>
								</div>

								<div id="issue-new-comment-container" class="w-100 align-items-start">
									<textarea class="form-control" id="issue-new-comment" contenteditable="true" style="height:37.5px; resize:none;" onkeyup="Anvil.page.modal.adjustHeight()" placeholder="Új megjegyzés"></textarea>

									<button class="btn btn-primary ms-1" id="issue-new-comment-send" onclick="Anvil.page.modal.saveComment()"><i class="fa fa-fw fa-paper-plane"></i></button>
									<button class="btn btn-primary ms-1" id="issue-new-comment-edit" onclick="Anvil.page.modal.editCommentCommit()"><i class="fa fa-fw fa-check"></i></button>
									<button class="btn btn-secondary ms-1" id="issue-new-comment-cancel" onclick="Anvil.page.modal.editCommentCancel()"><i class="fa fa-fw fa-times"></i></button>
								</div>
								<% } %>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>
<script>
Anvil.page.modal = Object.assign(Anvil.page.modal, {

	init () {

		// Handle dirty state event
		Anvil.page.modal.issue.record.on('dirty-state', (state) => {
			if (state) {
				$('.modal-content').addClass('dirty')
			} else {
				$('.modal-content').removeClass('dirty')
			}
		})
	},

	// Comment textarea mode
	editingCommentId: null,

	// Adjust comment textarea height
	adjustHeight () {
		const el = document.getElementById('issue-new-comment');
		el.style.height = '5px';
		el.style.height = Math.min(el.scrollHeight, 300) + 'px';
	},

	// Save new comment
	async saveComment () {
		const comment = document.getElementById('issue-new-comment').value.trim()
		if (comment.length < 1) {
			return
		}

		const res = await Anvil.exec('issue/action_add_comment', comment)

		if (res === true) {

			// Clear textarea
			document.getElementById('issue-new-comment').value = ''
			Anvil.page.modal.adjustHeight()

			// Re-render thread panel
			await Anvil.render('/issue/modal_edit_panel_thread', { issue: Anvil.page.modal.issue }, '#issue-thread')

			// Scroll to bottom
			const thread = document.getElementById('issue-thread')
			thread.scrollTop = thread.scrollHeight
		}
	},

	async editComment (note_id) {
		const comment = Anvil.page.modal.issue.notes.find(n => n.id == note_id)
		if (!comment) {
			return
		}

		Anvil.page.modal.editingCommentId = note_id

		// Show edit buttons
		$('#issue-new-comment-container').addClass('edit')

		// Fill textarea
		const ta = document.getElementById('issue-new-comment')
		ta.value = comment.description
		Anvil.page.modal.adjustHeight()
		ta.focus()
	},

	async editCommentCommit () {
		if (!Anvil.page.modal.editingCommentId) {
			return
		}

		const comment = document.getElementById('issue-new-comment').value.trim()
		if (comment.length < 1) {
			return
		}

		const res = await Anvil.exec('issue/action_edit_comment', Anvil.page.modal.editingCommentId, comment)

		if (res === true) {

			Anvil.page.modal.editingCommentId = null

			// Hide edit buttons
			$('#issue-new-comment-container').removeClass('edit')

			// Clear textarea
			document.getElementById('issue-new-comment').value = ''
			Anvil.page.modal.adjustHeight()

			// Re-render thread panel
			await Anvil.render('/issue/modal_edit_panel_thread', { issue: Anvil.page.modal.issue }, '#issue-thread')

			// Scroll to bottom
			const thread = document.getElementById('issue-thread')
			thread.scrollTop = thread.scrollHeight
		}
	},

	async editCommentCancel () {

		Anvil.page.modal.editingCommentId = null

		// Hide edit buttons
		$('#issue-new-comment-container').removeClass('edit')

		// Clear textarea
		document.getElementById('issue-new-comment').value = ''
		Anvil.page.modal.adjustHeight()
	},

	// Delete comment
	async deleteComment (note_id) {

		const res = await Anvil.exec('issue/action_delete_comment', note_id)

		if (res === true) {
			// Re-render thread panel
			Anvil.render('/issue/modal_edit_panel_thread', { issue: Anvil.page.modal.issue }, '#issue-thread')
		}
	},

	async save (lock) {

		const id = Anvil.page.modal.issue.id

		if (lock !== undefined) {
			Anvil.page.modal.issue.closed = lock
		}

		const res = await Anvil.exec('issue/action_save', Anvil.page.modal.issue)

		if (res === true) {

			// Refresh list
			if ('refresh' in Anvil.page) {
				Anvil.page.refresh()
			}

			// Focus on issue
			/*
			let grid = Anvil.models.components.Grid.find('#issue_grid')
			grid.select(grid.list.getById(Anvil.page.modal.issue.id), true)
			*/

			if (lock === false) {
				// Reopen modal with updated data
				Anvil.exec('issue/modal_edit', id)
			} else {
				// Close modal
				Anvil.page.modal.close()
			}
		}
	}
})
</script>
